import styled from '@emotion/styled';
import { css_background, css_fill, css_gap, css_letter, css_medium_up, css_text, css_vh } from '~/emotion/theme';
import MicrositeRow from '~/components/MicrositeRow';
import MicrositeMapImg from '~/components/MicrositeMapImg';
import BetaSectionHeader from '~/editor/templates/beta/lib/BetaSectionHeader';
import type { MicrositeAddress } from '~/model';

const Frame = styled.div`
	position: relative;
	min-height: calc(${css_vh(60)} - (${css_gap('section')} * 2));
	background: ${css_fill()};
	overflow: hidden;
`;

const AddressCard = styled.div`
	position: relative;
	margin-top: ${css_gap('section', 2)};
	background: ${css_background()};
	padding: ${css_gap('section', 2)};
	box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
	max-width: 22rem;

	@media (${css_medium_up}) {
		position: absolute;
		left: ${css_gap('section')};
		top: 50%;
		margin-top: 0;
		transform: translateY(-50%);
	}
`;

const Eyebrow = styled.h3`
	margin: 0 0 ${css_gap()};
	text-transform: uppercase;
	letter-spacing: ${css_letter('md')};
	font-size: 0.75rem;
	font-weight: 700;
`;

const Address = styled.p`
	margin: 0;
	color: ${css_text('weak')};
	font-size: 0.95rem;
	line-height: 1.8;
	font-weight: 300;
`;

const Footer = styled.div`
	margin-top: ${css_gap('section', 2)};
`;

const Map = styled.div`
	height: 50vh;
`;

export default function MapBlockBeta({ id, address }: { id: string; address: MicrositeAddress }) {
	return (
		<MicrositeRow id={id} fill>
			<Frame>
				<Map>
					<MicrositeMapImg lat={address.lat} lng={address.long} />
				</Map>
				<AddressCard>
					<Eyebrow>Address</Eyebrow>
					<Address>
						{address.line1}
						<br />
						{address.city}, {address.state} {address.zip}
					</Address>
					<Footer>
						<BetaSectionHeader title="Map" />
					</Footer>
				</AddressCard>
			</Frame>
		</MicrositeRow>
	);
}
